import { FirebaseAuthConsumer } from '@smart-maps/firebase';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

import { RESPONSIVE_MOBILE_WIDTH, ZINDEX } from '../../constants';
import CloseButton from './close-button';
import FiltersView from './filters';
import LoginView from './login';
import Navigation from './navigation';
import ProfileView from './profile';
import TrophiesView from './trophies';

const useStyles = createUseStyles({
  menu: {
    '&.ismobile': {
      left: 0,
      top: 0,
      width: '100%',
    },
    composes: ['is-absolute'],
    left: 12,
    top: 12,
    width: 320,
    zIndex: ZINDEX.MAP_CONTROLS,
  },
  panel: {
    '&.opened': {
      height: 'auto',
      paddingBottom: 12,
      paddingTop: 12,
    },
    height: 0,
    transition: 'height 0.3s',
  },
  wrapper: {
    '.ismobile &': { borderRadius: 0 },
    borderRadius: 12,
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.45)',
    composes: ['is-relative', 'flex-rows', 'no-overflow'],
    height: '100%',
    width: '100%',
  },
});

const MenuComponent = React.memo(({ lmap }) => {
  const classes = useStyles();
  const view = useSelector(_ => _.navigation);

  const ismobile = useMediaQuery({ maxWidth: RESPONSIVE_MOBILE_WIDTH });
  const opened = view !== null;

  return (
    <div className={classnames(classes.menu, { ismobile })}>
      <div
        className={classnames(classes.wrapper, 'smart-maps-menu', { opened })}>
        <Navigation opened={view} />
        <FirebaseAuthConsumer>
          {({ user }) => (
            <div className={classnames(classes.panel, { opened })}>
              {view === 'login' && !user && <LoginView />}
              {view === 'login' && user && <ProfileView user={user} />}
              {view === 'filters' && <FiltersView />}
              {view === 'trophy' && <TrophiesView lmap={lmap} />}
            </div>
          )}
        </FirebaseAuthConsumer>
        {opened && <CloseButton />}
      </div>
    </div>
  );
});

MenuComponent.propTypes = {
  lmap: PropTypes.shape().isRequired,
};

MenuComponent.displayName = 'MenuComponent';

export default MenuComponent;
